import { render, staticRenderFns } from "./LandingWeddingIT.vue?vue&type=template&id=47fddef9&scoped=true"
import script from "./LandingWeddingIT.vue?vue&type=script&lang=js"
export * from "./LandingWeddingIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fddef9",
  null
  
)

export default component.exports